var _tspan, _tspan2, _tspan3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogue2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 424,
    height: 102.497,
    viewBox: "0 0 424 102.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9357",
    transform: "translate(-976 -653)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8698",
    width: 424,
    height: 80,
    rx: 16,
    transform: "translate(976 653)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8353",
    transform: "translate(992 681)",
    style: {
      stroke: "#9da7b2",
      strokeWidth: 2,
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 3,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8643"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41427",
    d: "M1113.607-1363.289c0-.643-.026-1.288 0-1.93a2.41 2.41 0 0 0-1.468-2.456 5.422 5.422 0 0 1-2.615-2.49c-.147-.3-.283-.609-.426-.913-.727-1.547-1.45-3.095-2.182-4.639a2.717 2.717 0 0 1 .513-3.227c.234-.26.467-.523.686-.8a2.957 2.957 0 0 0 .662-2.248 2.067 2.067 0 0 1 2.374-2.286.917.917 0 0 1 .133.67q.007 2.807 0 5.615a1.037 1.037 0 0 0 .372.936c.247.179.363.13.4-.169a3.52 3.52 0 0 0 .009-.438v-5.7a.9.9 0 0 1 .131-.67v-13.521a2.317 2.317 0 0 1 2.308-2.369 2.292 2.292 0 0 1 2.347 2.319c.009 3.19 0 6.38 0 9.57v.482a2.452 2.452 0 0 1 3-1.587 2.181 2.181 0 0 1 1.5 1.309 6.749 6.749 0 0 1 .192 2c.858-1.493 1.743-2.048 2.834-1.747 1.014.28 1.884.956 1.877 2.824a3.444 3.444 0 0 1 .6-.927 1.922 1.922 0 0 1 2.186-.406 1.948 1.948 0 0 1 1.238 1.9c.022 1.9.007 3.8.007 5.707 0 2.107-.034 4.215.011 6.321a17.353 17.353 0 0 1-.646 5.059 11.484 11.484 0 0 0-.427 2.979c0 .276-.049.551-.076.827z",
    transform: "translate(-111.413 2118.785)",
    style: {
      fill: "#eab4ac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41428",
    d: "M1143.561-1276.052v6.876c0 .135.071.312-.094.4s-.3 0-.443-.1a1.023 1.023 0 0 1-.519-.936c.011-2.161.007-4.321.007-6.482a3.2 3.2 0 0 1 1.049.242z",
    transform: "translate(-142.777 2010.803)",
    style: {
      fill: "#dda97d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41429",
    d: "M1164.058-1463.484c0-.715.009-1.431 0-2.145 0-.245.069-.321.319-.328 1-.027 1-.036 1 .955 0 1.211-.007 2.423.005 3.634 0 .262-.065.349-.34.353-.98.013-.98.024-.98-.936q-.004-.767-.004-1.533z",
    transform: "translate(-161.597 2176.467)",
    style: {
      fill: "#0b97bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41430",
    d: "M1108.927-1440.381c-.056.068-.1.125-.148.176-.185.188-.38.366-.555.562-.14.157-.24.151-.389 0-1.029-1.04-2.066-2.072-3.1-3.107-.031-.031-.087-.061-.089-.094-.02-.446.436-.544.626-.841.085-.133.189-.2.346-.042 1.05 1.061 2.108 2.113 3.162 3.17.05.05.09.108.147.176z",
    transform: "translate(-109.709 2157.123)",
    style: {
      fill: "#0b97bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41431",
    d: "M1083.911-1382.82c-.7 0-1.4-.009-2.1 0-.258.005-.354-.062-.359-.341-.016-.981-.028-.98.943-.98 1.184 0 2.367.01 3.551-.007.33 0 .459.067.451.43-.019.893 0 .893-.9.893z",
    transform: "translate(-89.444 2105.001)",
    style: {
      fill: "#0d98bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41432",
    d: "M1219.672-1382.01c-.7 0-1.4-.01-2.107.005-.27.006-.346-.086-.351-.351-.019-.971-.028-.971.952-.971 1.2 0 2.4.01 3.6-.007.309 0 .395.089.393.4-.006.928.007.928-.907.928z",
    transform: "translate(-208.026 2104.293)",
    style: {
      fill: "#0c97bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41433",
    d: "M1204.368-1443.872a3.669 3.669 0 0 0 .49.573c.364.283.307.477-.006.777-.949.907-1.874 1.842-2.788 2.785-.239.247-.377.306-.643.02-.6-.644-.616-.628.018-1.262l2.6-2.6c.081-.081.17-.152.329-.293z",
    transform: "translate(-193.84 2157.17)",
    style: {
      fill: "#0c97bb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9356"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45694",
    d: "M-2697.007 976q0 9.818.006 19.636c0 .28-.043.366-.35.366q-19.657-.014-39.314 0c-.29 0-.335-.07-.335-.343q.012-19.655 0-39.311c0-.262.031-.347.331-.347q19.677.016 39.353 0c.273 0 .316.063.316.323q-.014 9.837-.007 19.676z",
    transform: "translate(3769 -283)",
    style: {
      fill: "#fefefe"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45695",
    d: "M-2687.953 999.221c1.092.62 2.188 1.234 3.276 1.861q4.5 2.589 8.987 5.188c.12.069.264.109.345.238.028.171-.112.218-.218.282-2.439 1.458-4.92 2.844-7.375 4.276-2.545 1.484-5.118 2.92-7.649 4.428-2.051 1.221-4.159 2.346-6.185 3.608a1.154 1.154 0 0 1-.391.171.652.652 0 0 1-.436-.135q-3.365-1.951-6.733-3.894-2.19-1.257-4.394-2.494c-.26-.146-.507-.312-.775-.445-.135-.068-.279-.155-.267-.347a.5.5 0 0 1 .291-.3c1.246-.695 2.469-1.431 3.7-2.145q1.9-1.1 3.8-2.21 2.621-1.531 5.249-3.049 1.531-.888 3.055-1.79c.815-.481 1.633-.959 2.461-1.419.976-.542 1.913-1.15 2.9-1.668a1.1 1.1 0 0 1 .359-.156z",
    transform: "translate(3744.604 -321.719)",
    style: {
      fill: "#f0c30f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45696",
    d: "M-2588.815 1081.873c1.31-.76 2.609-1.538 3.931-2.275 1.818-1.014 3.579-2.124 5.4-3.14 2.361-1.32 4.688-2.7 7.028-4.056q2.648-1.533 5.292-3.072a1.129 1.129 0 0 0 .17-.151 3.859 3.859 0 0 1 1.877 2.714 2.178 2.178 0 0 1 .041.809 1.326 1.326 0 0 1-.714 1.042c-.69.383-1.369.786-2.05 1.185-.12.071-.264.111-.344.24a4.015 4.015 0 0 1-.969.635q-4.006 2.329-8.014 4.654c-3.223 1.869-6.437 3.751-9.664 5.612a.543.543 0 0 1-.36.123c-.116-.051-.1-.15-.06-.229a2.692 2.692 0 0 0-.222-2.345 4.2 4.2 0 0 0-1.121-1.418c-.101-.087-.26-.145-.221-.328z",
    transform: "translate(3636.256 -384.39)",
    style: {
      fill: "#d5b118"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45697",
    d: "M-2567.232 1133.639a3.886 3.886 0 0 1 1.928 3.313 1.321 1.321 0 0 1-.74 1.27q-7.228 4.18-14.441 8.385-3.281 1.907-6.564 3.811c-.145.084-.3.154-.446.231-.015-.277.152-.513.176-.782a.832.832 0 0 0-.009-.517 4.127 4.127 0 0 0-1.512-2.612c-.109-.089-.234-.166-.246-.328a.361.361 0 0 1 .213-.258c1.916-1.088 3.813-2.209 5.717-3.318q2.151-1.253 4.31-2.493c1.594-.92 3.173-1.867 4.769-2.784 1.81-1.039 3.607-2.1 5.417-3.138a13.973 13.973 0 0 1 1.428-.78z",
    transform: "translate(3636.494 -442.135)",
    style: {
      fill: "#d5b118"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45698",
    d: "M-2675.867 1127.406a5.606 5.606 0 0 1-1.337.832 399.755 399.755 0 0 1-4.98 2.919c-1.5.866-3.005 1.711-4.5 2.58-1.542.9-3.071 1.817-4.613 2.714-1.44.838-2.891 1.656-4.333 2.49-.691.4-1.372.816-2.057 1.224-.168.114-.3 0-.427-.078-2.6-1.52-5.217-3.006-7.817-4.523-1.379-.8-2.771-1.586-4.146-2.4-.128-.075-.309-.11-.269-.326.157-.271.47-.306.7-.464a9.438 9.438 0 0 1 1.246-.715.524.524 0 0 1 .473.1c1.95 1.133 3.907 2.253 5.858 3.382 1.458.844 2.911 1.7 4.38 2.522a1.356 1.356 0 0 0 1.338.078c.1-.048.2-.041.3-.079l5.537-3.227c1.893-1.1 3.792-2.185 5.686-3.282 1.815-1.052 3.619-2.123 5.439-3.164.774-.443 1.514-.948 2.33-1.316z",
    transform: "translate(3745.129 -435.902)",
    style: {
      fill: "#f0c30f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45699",
    d: "M-2712.448 1130.311a1.369 1.369 0 0 1-1.662.1c-1.927-1.1-3.844-2.227-5.767-3.34q-2.3-1.329-4.6-2.652a.263.263 0 0 0-.29-.03 4.459 4.459 0 0 1-.733-.483 4.432 4.432 0 0 0-1.072-.677 4.089 4.089 0 0 1-2.063-3.112 1.352 1.352 0 0 1 .813-1.579c.451-.2.808.065 1.184.239.154.383.566.426.858.6 1.054.643 2.149 1.218 3.22 1.834 1.9 1.094 3.794 2.2 5.692 3.3q1.275.739 2.557 1.467a.746.746 0 0 0 .224.046 5.648 5.648 0 0 1 1.245 1.365 3.457 3.457 0 0 1 .552 2.392c-.035.185-.228.319-.158.53z",
    transform: "translate(3761.525 -428.542)",
    style: {
      fill: "#e4bc13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45700",
    d: "M-2726.7 1183.57c.106.292.418.324.632.452 1.058.635 2.149 1.214 3.217 1.832 1.245.72 2.473 1.47 3.718 2.189 1.268.732 2.55 1.439 3.822 2.165a7.177 7.177 0 0 0 1.239.687 6.693 6.693 0 0 1 1.25 1.362 3.7 3.7 0 0 1 .542 1.6.867.867 0 0 1 0 .543 1.34 1.34 0 0 1-.235.746 1.336 1.336 0 0 1-1.691.026q-2.88-1.666-5.761-3.329-3.286-1.9-6.573-3.79a4.085 4.085 0 0 1-2.079-3.117 1.379 1.379 0 0 1 .673-1.522 1.318 1.318 0 0 1 .656-.095 1.166 1.166 0 0 1 .59.251z",
    transform: "translate(3761.51 -486.633)",
    style: {
      fill: "#e4bc13"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45701",
    d: "M-2719.439 1009.86c-.3.121-.477-.253-.772-.2a1.435 1.435 0 0 1-.412-.042c1.192-.7 2.38-1.415 3.577-2.111l17.814-10.362a1.327 1.327 0 0 1 1.554-.018 18.241 18.241 0 0 1-1.95 1.182c-1.013.623-2.053 1.2-3.082 1.8l-3.615 2.1c-.749.436-1.493.879-2.244 1.312-1.386.8-2.778 1.592-4.162 2.4-1.652.961-3.292 1.943-4.951 2.892-.592.341-1.188.671-1.757 1.047z",
    transform: "translate(3754.329 -319.627)",
    style: {
      fill: "#d5b118"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45702",
    d: "M-2718.653 1172.248a1.459 1.459 0 0 1-.548-.157c-.129-.125-.363.081-.459-.145l2.222-1.273c.283.1.587.172.733.483z",
    transform: "translate(3753.466 -475.311)",
    style: {
      fill: "#d5b118"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45703",
    d: "M-2721.719 1182.892c.119.157.343-.021.46.145h-.7z",
    transform: "translate(3755.525 -486.258)",
    style: {
      fill: "#e8cb50"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45704",
    d: "M-2613.348 1051.748a2.812 2.812 0 0 1 1.75.549q3.193 1.859 6.394 3.705c.079.045.156.092.231.144a.689.689 0 0 1 0 1.255c-.8.5-1.626.968-2.442 1.447-.917.538-1.833 1.077-2.755 1.607a2.573 2.573 0 0 1-2.7.05q-3.53-2.014-7.038-4.069c-.6-.348-.589-.942.02-1.324.669-.42 1.36-.806 2.044-1.2 1.042-.607 2.088-1.207 3.127-1.818a2.191 2.191 0 0 1 1.369-.346z",
    transform: "translate(3664.499 -368.764)",
    style: {
      fill: "#e64c3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45705",
    d: "M-2571.559 1285.1v-.543a.448.448 0 0 1 0 .543z",
    transform: "translate(3620.793 -577.336)",
    style: {
      fill: "#e1c444"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45706",
    d: "M-2668.516 1157.618v1.358c-.231 0-.317-.1-.315-.306 0-.545.007-1.09 0-1.636 0-.215.081-.2.232-.123a.618.618 0 0 1 .337.4c.128.432.285.856.458 1.364.154-.273.26-.487.391-.684.061-.092.058-.3.242-.234.157.06.375.1.378.337.007.584 0 1.168 0 1.753 0 .059.006.151-.088.131a.236.236 0 0 1-.215-.238V1158.406c-.247.184-.3.446-.454.637-.067.086-.072.257-.216.241s-.167-.178-.209-.3q-.243-.688-.484-1.377z",
    transform: "translate(3707.932 -462.936)",
    style: {
      fill: "#484c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45707",
    d: "M-2626.239 1183.331a.563.563 0 0 1-.459-.382 20.498 20.498 0 0 0-.87-1.67c-.016.322-.028.644-.051.965-.006.091.055.239-.085.256s-.193-.1-.193-.235v-1.856c.269 0 .335.177.414.339.287.594.575 1.187.922 1.779v-1.349c.26.022.329.138.326.341-.009.596-.004 1.192-.004 1.812z",
    transform: "translate(3671.262 -484.033)",
    style: {
      fill: "#494c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45708",
    d: "M-2683.923 1149.489c-.388-.225-.757-.44-1.127-.651a.258.258 0 0 1-.151-.247v-1.927l1.2.7a.194.194 0 0 1 .086.268c-.069.13-.159.011-.225-.024-.227-.119-.447-.251-.7-.394-.1.328-.076.555.248.69a4.083 4.083 0 0 1 .471.273.177.177 0 0 1 .084.234c-.063.142-.151.029-.22 0a2.933 2.933 0 0 0-.591-.3.483.483 0 0 0 .287.69c.178.074.334.2.508.287.153.073.2.183.13.401z",
    transform: "translate(3722.597 -453.803)",
    style: {
      fill: "#4a4d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45709",
    d: "M-2644.621 1170.215c.465.36 1.04.435 1.29.925l-.079.106-.854-.472a.517.517 0 0 0 .3.727c.205.111.567.131.5.576l-.8-.44a.509.509 0 0 0 .3.726 4.1 4.1 0 0 1 .569.333.188.188 0 0 1 .07.242c-.066.133-.15.02-.225-.009-.024-.009-.043-.031-.067-.039a1.347 1.347 0 0 1-1.009-1.7 6.022 6.022 0 0 0 .005-.975z",
    transform: "translate(3686.285 -474.901)",
    style: {
      fill: "#494c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45710",
    d: "M-2704.61 1139.85c0-.694.4-.933.934-.649a1.686 1.686 0 0 1 .644.609c.049.078.1.163 0 .239-.123.093-.152-.033-.2-.1a1.086 1.086 0 0 0-.535-.435c-.27-.083-.457 0-.508.3a1.151 1.151 0 0 0 1.005 1.273.244.244 0 0 1 .253.272c-.01.165-.185.155-.308.123a1.683 1.683 0 0 1-1.154-1.118 3.676 3.676 0 0 1-.131-.514z",
    transform: "translate(3739.984 -447.013)",
    style: {
      fill: "#494d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45711",
    d: "M-2608.769 1190.923c.467.338 1.046.489 1.4.934l-.081.109c-.023 0-.05.013-.068 0-.449-.226-.449-.227-.45.273v1.164c-.26 0-.318-.131-.314-.329.007-.389-.011-.779.009-1.167a.475.475 0 0 0-.31-.549c-.156-.058-.317-.151-.186-.435z",
    transform: "translate(3654.168 -493.452)",
    style: {
      fill: "#4b4e57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45712",
    d: "M-2668.835 1220.84c.85.37.635 1.253 1.062 1.812.12-.211.226-.418.353-.61.067-.1.078-.323.288-.224.154.072.345.12.341.367-.01.608 0 1.217-.057 1.833-.5-.436-.094-1.044-.32-1.582-.119.2-.226.4-.349.582-.075.112-.1.314-.261.3s-.175-.2-.221-.335a11.587 11.587 0 0 0-.529-1.337v1.37c-.228-.008-.311-.1-.309-.294.005-.607.002-1.215.002-1.882z",
    transform: "translate(3707.937 -520.253)",
    style: {
      fill: "#484c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45713",
    d: "M-2627.7 1247.245c-.27-.04-.269-.21-.268-.386 0-.479 0-.958.007-1.437 0-.094-.059-.24.063-.274.142-.039.231.087.289.205.178.359.35.721.526 1.082a4.287 4.287 0 0 0 .465.794c0-.349-.007-.7.005-1.048 0-.09-.088-.267.106-.261.145 0 .2.125.2.279-.006.606 0 1.213-.055 1.844-.649-.526-.778-1.37-1.274-2.078z",
    transform: "translate(3671.335 -542.021)",
    style: {
      fill: "#494c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45714",
    d: "M-2683.921 1214.8c-.389-.222-.767-.441-1.148-.655-.125-.07-.126-.181-.125-.3 0-.518.007-1.036 0-1.553 0-.233.072-.279.271-.158.287.174.58.34.872.508.111.064.2.164.141.281-.093.173-.2 0-.284-.037-.216-.107-.423-.235-.638-.357-.171.41.034.586.338.752.2.107.53.139.45.549l-.8-.432a.506.506 0 0 0 .312.727c.167.066.311.186.473.266s.216.209.138.409z",
    transform: "translate(3722.592 -512.398)",
    style: {
      fill: "#4a4d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45715",
    d: "M-2644.25 1235.517c.794.267 1.254.626 1.218.956l-.859-.469c-.1.335-.063.563.261.689.143.056.267.16.4.231.123.063.2.167.133.281-.079.141-.175-.006-.255-.038-.189-.074-.334-.242-.552-.269a.481.481 0 0 0 .294.686 4.738 4.738 0 0 1 .572.329.181.181 0 0 1 .075.239c-.064.127-.153.04-.226 0-.3-.173-.6-.352-.91-.524a.254.254 0 0 1-.156-.242c.006-.62.005-1.239.005-1.869z",
    transform: "translate(3685.913 -533.4)",
    style: {
      fill: "#494c58"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45716",
    d: "M-2704.608 1204.406c0-.621.4-.864.934-.586a1.647 1.647 0 0 1 .62.574c.049.075.171.158.044.262s-.173-.031-.227-.106a1.182 1.182 0 0 0-.433-.381c-.332-.17-.563-.047-.6.316a1.158 1.158 0 0 0 1.018 1.228.239.239 0 0 1 .245.275c-.017.162-.2.153-.316.121a1.755 1.755 0 0 1-1.123-1.052 2.031 2.031 0 0 1-.162-.651z",
    transform: "translate(3739.982 -504.903)",
    style: {
      fill: "#4a4d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45717",
    d: "M-2608.8 1255.511a5.67 5.67 0 0 1 1.38.956c-.24.114-.349-.114-.572-.072v1.613c-.247-.016-.322-.13-.317-.335.009-.375-.013-.752.01-1.126a.523.523 0 0 0-.334-.614.268.268 0 0 1-.167-.422z",
    transform: "translate(3654.2 -551.312)",
    style: {
      fill: "#4b4e57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45718",
    d: "M-2563.045 1085.964c-.2.032-.409.069-.614.1-.1.012-.213.1-.283-.024-.053-.092.054-.161.088-.24s.081-.159.133-.259c-.373-.105-.562.389-1.021.217.426-.246.785-.459 1.149-.662.126-.07.224.032.308.1.1.084 0 .161-.041.234-.058.113-.123.223-.2.365.45.112.887-.312 1.313.013-.5.437-1.052.7-1.305.6l.562-.353c.056-.124-.005-.117-.089-.091z",
    transform: "translate(3614.685 -398.624)",
    style: {
      fill: "#fdf9f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45719",
    d: "M-2535.477 1101.725c.387-.078.611-.478 1.118-.368-.425.247-.76.439-1.093.637a.229.229 0 0 1-.284 0c-.1-.072-.066-.152-.047-.24.041-.2.078-.4.123-.634a3.13 3.13 0 0 0-.718.361c-.088.044-.188.078-.237-.021s.073-.118.131-.153c.277-.167.556-.332.839-.488.215-.119.327-.043.3.2s-.084.454-.132.706z",
    transform: "translate(3589.498 -412.686)",
    style: {
      fill: "#fdf9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45720",
    d: "M-2547.414 1095.657c-.34-.042-.58-.305-.962-.474.41-.238.76-.439 1.107-.644.148-.087.245.023.352.083.185.1.364.218.588.354-.42.218-.682-.509-1.066-.093.1.187.354.173.448.373-.339.188-.6-.51-.963-.058l.55.351z",
    transform: "translate(3600.024 -407.079)",
    style: {
      fill: "#fdf6f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45721",
    d: "M-2574.622 1080.456c-.454.051-.677-.3-1.079-.418l.725-.424c.553-.324.793-.282 1.279.234-.368.163-.611-.518-1-.128.1.175.329.187.455.364-.352.2-.618-.495-.963-.067.122.191.392.205.583.439z",
    transform: "translate(3624.502 -393.552)",
    style: {
      fill: "#fdf7f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45722",
    d: "M-2584.062 1073.872c-.062.032-.084.052-.107.053-.419.015-.819-.2-.848-.462s.32-.516.779-.546a1.14 1.14 0 0 1 .9.285c.061.057.155.145.074.226s-.184.048-.26-.055a.732.732 0 0 0-.866-.237c-.15.042-.305.108-.311.3s.161.245.3.307c.096.042.227-.003.339.129z",
    transform: "translate(3632.85 -387.735)",
    style: {
      fill: "#fdf7f6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45723",
    d: "m-2520.777 1108.972.9-.542c-.024-.151-.19-.137-.235-.237a.15.15 0 0 1 .238-.055c.11.068.229.122.335.2.142.1.445.184.4.289-.108.229-.267-.078-.413-.062-.306.033-.52.269-.788.39-.128.053-.243.224-.437.017z",
    transform: "translate(3575.3 -419.257)",
    style: {
      fill: "#fdf5f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 45724",
    d: "M-2548.451 1093.074a.258.258 0 0 1 .275-.049c-.031.095-.111.114-.19.135z",
    transform: "translate(3600.091 -405.735)",
    style: {
      fill: "#ee867c"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8699",
    width: 86,
    height: 10,
    rx: 5,
    transform: "translate(1088 681)",
    style: {
      fill: "#9da7b2",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8700",
    width: 86,
    height: 10,
    rx: 5,
    transform: "translate(1088 695)",
    style: {
      fill: "#9da7b2",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8701",
    transform: "translate(1190 673)",
    style: {
      stroke: "#9da7b2",
      strokeWidth: 2,
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 40,
    rx: 4,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 38,
    rx: 3,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 8702",
    transform: "translate(1280 673)",
    style: {
      stroke: "#9da7b2",
      strokeWidth: 2,
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 40,
    rx: 4,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 72,
    height: 38,
    rx: 3,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": 40,
    transform: "translate(1252 697)",
    style: {
      fill: "#6c7c8c",
      fontSize: 12,
      fontFamily: "Inter-Regular,Inter"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -15.205,
    y: 0
  }, "40"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1202 697)",
    style: {
      fill: "#6c7c8c",
      fontSize: 12,
      fontFamily: "Inter-Regular,Inter"
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Qty"))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1292 697)",
    style: {
      fill: "#6c7c8c",
      fontSize: 12,
      fontFamily: "Inter-Regular,Inter"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MRP"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9173",
    transform: "translate(-21149 21017)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 243",
    width: 24,
    height: 24,
    rx: 4,
    transform: "translate(22141 -20336)",
    style: {
      fill: "#015fe5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "check (2)",
    d: "m14 6-6.875 6.875L4 9.75",
    transform: "translate(22144 -20333.5)",
    style: {
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      fill: "none"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogue2);
export default __webpack_public_path__ + "static/media/catalogue2.5ce44347adba8267d9e04eb2d7115260.svg";
export { ForwardRef as ReactComponent };